import { render, staticRenderFns } from "./RotaryConfigDialog.vue?vue&type=template&id=447b1fd5&scoped=true&"
import script from "./RotaryConfigDialog.vue?vue&type=script&lang=js&"
export * from "./RotaryConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447b1fd5",
  null
  
)

export default component.exports